import { ENV } from './environment';

export const API_CONFIG = {
  baseURL: ENV.API_BASE_URL,
  timeout: 15000,
  retryAttempts: 2,
  headers: {
    'X-Client-Version': ENV.VERSION,
    'X-Platform-ID': 'cyzor-web',
  },
} as const;
